// TODO: I think we are going to support more currencies.

import { SupportedCountryCurrency } from '../../../types/supported-country-currency';

// But for now that is what we have because the currency is typed as SupportedCountryCurrency
export const isSupportedCurrency = (currency?: string): currency is SupportedCountryCurrency => {
  if (!currency) {
    return false;
  }

  switch (currency) {
    case 'EUR':
    case 'GBP':
    case 'USD':
      return true;
    default:
      return false;
  }
};
